import React from 'react';
import Logo from '../assets/azf-logo-white.png';
import Youtube_Logo from '../assets/Link - Youtube.png';
import Insta_Logo from '../assets/Link - Instagram.png';


const FooterSection = () => (
  <footer className="footer-section">
    <div className="footer-top">
      <div className="footer-logo">
        <img src={Logo} className="footer-icon" role="img" aria-label="logo"/>
        <span className="footer-title">Abdullah Zaman Foundation</span>
      </div>
      <nav className="footer-nav">
        <a href="#home">Home</a>
        <a href="#about">About</a>
        <a href="#impacts">Impact</a>
        <a href="#process">How It Works</a>
        <a href="#contact">Contact</a>
        {/* <a href="#terms">Terms of Service</a>
        <a href="#privacy">Privacy Policy</a> */}
      </nav>
    </div>
    <div className="footer-desc">
      We believe that access to Islamic education transforms lives. Abdullah Zaman Foundation is dedicated to supporting students who seek deeper understanding of Islam by providing them with the financial assistance they need to do so.
    </div>
    <div className="footer-bottom">
      <div className="footer-copyright">
        2025 Abdullah Zaman Foundation. All rights reserved.
      </div>
      {/* <div className="footer-social">
        <a href="#" className="icon-btn" aria-label="YouTube"><img src={Youtube_Logo} className="footer-icon" role="img" aria-label="logo"/></a>
        <a href="#" className="icon-btn" aria-label="Instagram"><img src={Insta_Logo} className="footer-icon" role="img" aria-label="logo"/></a>
      </div> */}
    </div>
  </footer>
);

export default FooterSection;
